import { html, onClickOutside, onDelegatedClick } from '../functions.js';

export default class WhatsappNotifications extends HTMLElement {

    #currentCount = 0;
    #panelShown = false; 

    connectedCallback() {

        let imageUrl = this.dataset.rootUrl + 'img/icon-whatsapp-white.svg';
        
        this.innerHTML = html`
            <a href="" class="wn__icon">
                <img src="${imageUrl}" width="25">
            </a>
        `;

        this.#fetchCount();

        this.#bindEvents();

    }

    #bindEvents() {
        onDelegatedClick(this, '.wn__icon', (event) => {
            event.preventDefault();
            if (this.#panelShown) {
                this.querySelector('.wn__popup').remove();
                this.#panelShown = false;
            } else {
                this.#loadPanel();
            }
        });

        onDelegatedClick(this, '.wn__close', (event) => {
            event.preventDefault();
            this.#closePanel();
        });

        onClickOutside(this, (event) => {
            if (this.#panelShown) {
                this.#closePanel();
            }
        });
    }

    #closePanel() {
        this.querySelector('.wn__popup').remove();
        this.#panelShown = false;
    }

    #loadPanel() {
        let panelUrl = this.dataset.rootUrl + 'www4/whatsapp/notificationsPanel?userToken=' + encodeURIComponent(this.dataset.userToken) + '&t=' + Date.now();

        let newHtml = html`
            <div class="wn__popup">
                <a href="" class="wn__close">&times;</a>
                <sl-include src="${panelUrl}">
                    <sl-skeleton effect="pulse" style="margin-bottom: 0.5em"></sl-skeleton>
                    <sl-skeleton effect="pulse" style="margin-bottom: 0.5em"></sl-skeleton>
                    <sl-skeleton effect="pulse" style="margin-bottom: 0.5em"></sl-skeleton>
                    <sl-skeleton effect="pulse" style="margin-bottom: 0.5em"></sl-skeleton>
                    <sl-skeleton effect="pulse" style="margin-bottom: 0.5em"></sl-skeleton>
                    <sl-skeleton effect="pulse" style="margin-bottom: 0.5em"></sl-skeleton>
                </sl-include>
            </div>
        `;
        this.insertAdjacentHTML('beforeend', newHtml);

        this.#panelShown = true;
    }

    #fetchCount() {
        let countUrl = this.dataset.rootUrl + 'www4/whatsapp/streamCountUnread?userToken=' + encodeURIComponent(this.dataset.userToken);

        const evtSource = new EventSource(countUrl);

        evtSource.addEventListener('count', (event) => {
            let count = parseInt(event.data.trim(), 10);
            this.#updateCount(count);
        });

        evtSource.onerror = (err) => {
            console.error("EventSource failed:", err);
        };
    }

    #updateCount(count) {
        if (this.#currentCount === count) {
            return;
        }

        this.#currentCount = count;

        let countElement = this.querySelector('.wn__badge');

        if (!countElement) {
            countElement = document.createElement('span');
            countElement.classList.add('wn__badge');
            countElement.style.display = 'none';
            this.querySelector('.wn__icon').appendChild(countElement);
        } 

        countElement.textContent = this.#currentCount;
        
        if (this.#currentCount > 0) {
            countElement.style.display = 'block';
        } else {
            countElement.style.display = 'none';

        }

    }

};

window.customElements.define('whatsapp-notifications', WhatsappNotifications);